import React from 'react'
import Header from './Header'
import Footer from './Footer'

export default ({children}) => (
  <div>
    <Header />
    {children}
    <Footer />
  </div>
)


// WEBPACK FOOTER //
// ./src/scenes/Layout/BaseLayout/index.js